import React, { useState, useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate.js";
import qs from 'qs';
import { useHeader } from './../../components/HeaderContext';
import localeToPortuguese from "./../../components/funcoes_gerais.js";
import OkModal from "./../../components/OkModal.js";
import { encryptId } from './../../components/utils_react.jsx'
import useAuth from "./../../hooks/useAuth.js";
import { Checkbox } from '@mui/material';
import { Select } from 'antd';
import { format } from "date-fns";

const EditableDataGrid = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const axiosPrivate = useAxiosPrivate();

    const { auth } = useAuth();

    const { setHeader } = useHeader();

    useEffect(() => {
        setHeader("Permissions");
    }, [setHeader]);

    const last_modified_date = format(Date(), "dd-MM-yyyy HH:mm:ss");
    const last_modified_user_id = auth.user_id ? auth.user_id : 0;

    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    };

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setPageSize] = useState(20);
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState("sequence");
    const [sortOrder, setSortOrder] = useState("ASC");
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20 });


    //para guardar os valores dos campos
    const [filterData, setFilterData] = useState({
        group_id: '',
        group_name: ''
    })

    function handleConfirmChange() {
        console.log('How do I change row state here????');
    }

    const columns = [
        { field: 'menu_items_id', headerName: 'ID', disableColumnMenu: true },
        { field: 'sequence', headerName: 'Seq', width: 80, align: 'right', headerAlign: 'center', disableColumnMenu: true },
        { field: 'parent_key', headerName: 'parent_key', width: 180, align: 'left', headerAlign: 'center', disableColumnMenu: true },
        { field: 'menu_key', headerName: 'Menu Key', width: 260, headerAlign: 'center', disableColumnMenu: true },
        { field: 'description', headerName: 'Descrição', width: 340, disableColumnMenu: true },
        {
            field: 'has_permission',
            headerName: 'Active',
            disableColumnMenu: true,
            width: 150,
            renderCell: (params) => (
                <Checkbox
                    checked={params.value}
                    onChange={(event) => handleCheckboxChange(event, params)}
                    sx={{  // to render the checkbox in the middle of the row
                        padding: 0,
                        margin: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            ),
        },
    ];


    useEffect(() => {
        fetchGroupPermissions();
    }, [page, limit, sortField, sortOrder]);



    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForSelectGroup();
        };
        fetchData();
    }, []);



    const fetchGroupPermissions = async () => {

        // Check if grupo is empty, if so, exit the function early
        if (!filterData.group_id) {
            console.log("Grupo is empty, skipping API call.");
            return;
        }

        const queryString = qs.stringify(filterData);
        console.log("group_permissions.js > fetchGroupPermissions > queryString: ", queryString);

        let id = filterData.group_id;

        try {
            setLoading(true);
            const result = await axiosPrivate.get(`${baseURL}/group_permissions_page/${id}?page=${page + 1}&limit=${limit}&sortfield=${sortField}&sortorder=${sortOrder}&${queryString}`);
            //const result = await axiosPrivate.get(`${baseURL}/permissoes_page/` + id)
            //console.log("group_permissions.js > fetchGroupPermissions > result: ", result);
            if (result.status === 200) {
                setRows(result.data.result.map(row => ({ id: row.menu_items_id, ...row })));
                setTotalRows(result.data.total_count);
            } else {
                alert(result.data.Error);
            }
        } catch (error) {
            console.error('Failed to fetch products:', error);
        } finally {
            setLoading(false);
        }
    };


    const handlePageChange = (newPage, newPageSize) => {
        if (newPageSize === limit) {
            setPage(newPage);
            setPaginationModel({ ...paginationModel, page: newPage, pageSize: limit });
        } else {
            setPage(0);
            setPageSize(newPageSize);
            setPaginationModel({ ...paginationModel, page: 0, pageSize: newPageSize });
        }
    };

    const handleSortModelChange = (newSortModel) => {
        const { field, sort } = newSortModel[0] || {};
        if (field) {
            setPage(0);
            setSortField(field);
            setSortOrder(sort);
        } else {
            setSortField("sequence");
            setSortOrder("asc");
        }
        setPaginationModel({ ...paginationModel, page: 0 });
    };



    const handleCheckboxChange = async (event, params) => {
        const newValue = event.target.checked;
        // Update state
        const updatedRows = rows.map(row =>
            row.id === params.id ? { ...row, has_permission: newValue } : row
        );
        setRows(updatedRows);

        console.log("group_permissions.js > handleCheckboxChange > newValue: ", newValue);
        console.log("Checkbox changed: menu_key ", params.row.menu_key, "filterData.grupo : ", filterData.grupo);
        /*
        // Update database
        axios.post('/api/update', { id: params.id, active: newValue })
            .then(response => console.log('Update successful:', response))
            .catch(error => console.error('Error updating data:', error));
            */

        // Wrap both payloads in one
        const payload = {
            group_id: filterData.group_id,
            menu_key: params.row.menu_key,
            has_permission: newValue,
            last_modified_user_id: last_modified_user_id
        };

        console.log("group_permissions.js > handleCheckboxChange > payload: ", payload);


        await axiosPrivate.post(`${baseURL}/group_permissions_assign/`, payload)
            .then(response => {
                if (response.status === 200) {
                    console.log('Row updated successfully');
                }
            })
            .catch(error => {
                console.error('Error updating row:', error);
            });



    };


    const [optionsGroup, setOptionsGroup] = useState([]);
    const fetchDataForSelectGroup = async () => {
        try {
            const response = await axiosPrivate.get(`${baseURL}/group_list`);
            const data = response.data;

            // Update options for React Select
            const selectOptions = data.map(item => ({
                value: item.group_id,
                label: item.group_name + " - " + item.description,
            }));

            setOptionsGroup(selectOptions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };





    const handleChangeGroup = (selectedOption) => {
        if (selectedOption) {
            setFilterData({ ...filterData, group_id: selectedOption });
        } else {
            setFilterData({ ...filterData, group_id: '' }); // If the option is cleared
            setRows([]); // Clear the data grid if no value is selected
        }
    };


    const handleBtnSearch = async () => {
        console.log("group_permissions.js > handleBtnSearch > filterData.group_id: ", filterData.group_id);

        if (filterData.group_id === '') {
            handleShowOkModal("Please select a Group Name!", "warning")
            return; // Stop submission if any field is invalid
        } else {
            await fetchGroupPermissions();
        }
    };







    return (
        <div className="mt-2 ms-2">
            <div className="row w-100 mb-2">
                <div className="col-3">
                    <label htmlFor="grupo" className="form-label app_font1"> Group Name </label>
                    <Select
                        showSearch
                        optionFilterProp="label"
                        onChange={handleChangeGroup}
                        value={optionsGroup.find(option => option.value === filterData.grupo)}
                        allowClear
                        style={{ width: '100%' }}
                        options={optionsGroup}
                        className="d-block"
                    />
                </div>


                <div className="col-1 d-flex flex-column justify-content-end">
                    <div className="mt-auto">
                        <button type="button" className="btn btn-outline-success btn-sm mb-1" id="pesquisar" onClick={handleBtnSearch}>Search</button>
                    </div>
                </div>
            </div>


            <div style={{ width: '90%', position: 'relative' }}>
                <DataGrid

                    slotProps={{
                        pagination: {
                            showFirstButton: true,
                            showLastButton: true,
                        },
                    }}
                    className="center-header"
                    experimentalFeatures={{ newEditingApi: true }}
                    editMode="cell"
                    page={page - 1}
                    rows={rows}
                    columns={columns}
                    rowHeight={40}
                    disableRowSelectionOnClick={true}
                    autoHeight={true}
                    paginationMode="server"
                    sortingMode="server"
                    density="compact"
                    rowCount={totalRows}
                    pagination
                    pageSizeOptions={[20, 40, 60]}
                    onCellClick={(params) => {
                        console.log("===cell click===", params);
                    }}

                    onPaginationModelChange={(params) => {
                        handlePageChange(params.page, params.pageSize);
                    }}

                    paginationModel={paginationModel}
                    initialState={{
                        pagination: { paginationModel: { page: 0, pageSize: 20 } },
                        columns: { columnVisibilityModel: { menu_items_id: false } },
                    }}
                    onSortModelChange={handleSortModelChange}

                />
                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />

                {loading && (
                    <div className="overlay">
                        <div className="loading-circle"></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditableDataGrid;


